import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate("/");
  };

  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404 - Page Not Found</h1>
      <p className="not-found-message">
        Oops! The page you are looking for does not exist.
      </p>
      <Button
        label="Go to Home"
        icon="pi pi-home"
        className="p-button-rounded p-button-primary"
        onClick={redirectToHome}
      />
    </div>
  );
};

export default NotFoundPage;
